import { render, staticRenderFns } from "./SendPaperEdit.vue?vue&type=template&id=b28c180e&scoped=true"
import script from "./SendPaperEdit.vue?vue&type=script&lang=js"
export * from "./SendPaperEdit.vue?vue&type=script&lang=js"
import style0 from "./SendPaperEdit.vue?vue&type=style&index=0&id=b28c180e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28c180e",
  null
  
)

export default component.exports